
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/tickets-2022/[username]",
      function () {
        return require("private-next-pages/tickets-2022/[username].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/tickets-2022/[username]"])
      });
    }
  